import React, { useState } from 'react';
import { Collapse, Row, Col } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined } from 'iglooicon';

import './index.less';

interface Props {
  titleIconSrc: string;
  title: string;
  list: Array<{ label: string; value: React.ReactNode }>;
  noExtendIcon?: boolean;
  isExtend?: boolean;
}

const FoldCard = (props: Props) => {
  const {
    titleIconSrc,
    title,
    list,
    noExtendIcon = true,
    isExtend = true,
  } = props;
  const [isExpand, setIsExpand] = useState(isExtend);
  const { Panel } = Collapse;

  const header = (
    <div className="header">
      <img className={'header-icon'} src={titleIconSrc} />
      <span>{title}</span>
    </div>
  );

  const onChangeCollapse: (key: string | string[]) => void = (key) => {
    setIsExpand(key?.length > 0);
  };

  return (
    <div className="cardContainer">
      <Collapse
        collapsible={noExtendIcon ? 'disabled' : undefined}
        expandIconPosition="end"
        bordered={false}
        activeKey={isExpand ? ['1'] : []}
        expandIcon={(status) => {
          if (noExtendIcon) return null;
          return status.isActive ? (
            <ArrowUpOutlined style={{ fontSize: 24 }} />
          ) : (
            <ArrowDownOutlined style={{ fontSize: 24 }} />
          );
        }}
        onChange={onChangeCollapse}
      >
        <Panel header={header} key="1">
          <div className="detailContainer">
            {list.map((e, i) => (
              <Row key={i} justify="space-between" gutter={[0, 8]}>
                <Col>{e.label}</Col>
                <Col>{e.value}</Col>
              </Row>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default FoldCard;
